import { Box } from 'components/Box';
import { CmsApiCategoryHighlightBlockData } from 'modules/cms/api/types/CmsApiCategoryHighlight';
import { CmsAmpCardsBlock } from 'modules/cms/blocks/Amp/Cards';
import { CmsAmpBlockMappingComponentProps } from 'modules/cms/blocks/CmsBlockMapping';

export function CmsAmpCategoryHighlightBlock({
  blockId,
  content,
  data,
}: CmsAmpBlockMappingComponentProps<CmsApiCategoryHighlightBlockData>) {
  return (
    <CmsAmpCardsBlock
      blockId={blockId}
      content={content}
      data={{
        ...data,
        headline: data.headline,
        cards: data.categories.map((category) => ({
          headline: category.name,
          image: category.image,
          text: category.description,
          body: (
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
              {category.pages
                ? category.pages.map((page) => (
                    <Box
                      component="a"
                      href={page.url}
                      key={page.id}
                      display="block"
                    >
                      {page.title}
                    </Box>
                  ))
                : null}
            </>
          ),
        })),
      }}
    />
  );
}
